//pltfrm-landing/src/i18n/i18n.js

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import legacyEn from "./en.json";
import legacyPl from "./pl.json";
import legacyRu from "./ru.json";
import legacyUk from "./uk.json";

import enCommon from "./en/common.json";
import ukCommon from "./uk/common.json";
import plCommon from "./pl/common.json";
import ruCommon from "./ru/common.json";

import enNotifications from "./en/notifications.json";
import ukNotifications from "./uk/notifications.json";
import plNotifications from "./pl/notifications.json";
import ruNotifications from "./ru/notifications.json";

import enVoice from "./en/voice.json";
import ukVoice from "./uk/voice.json";
import plVoice from "./pl/voice.json";
import ruVoice from "./ru/voice.json";

import enPricingCommon from "./en/pricing/common.json";
import ukPricingCommon from "./uk/pricing/common.json";
import plPricingCommon from "./pl/pricing/common.json";
import ruPricingCommon from "./ru/pricing/common.json";

import enCommunityCommon from "./en/community/common.json";
import ukCommunityCommon from "./uk/community/common.json";
import plCommunityCommon from "./pl/community/common.json";
import ruCommunityCommon from "./ru/community/common.json";

import enAdminSidebar from "./en/admin/sidebar.json";
import enAdminDashboard from "./en/admin/dashboard.json";
import enAdminCourses from "./en/admin/courses.json";
import enAdminModules from "./en/admin/modules.json";
import enAdminLessons from "./en/admin/lessons.json";
import enAdminStudents from "./en/admin/students.json";
import enAdminPayments from "./en/admin/payments.json";
import enAdminProducts from "./en/admin/products.json";
import enAdminAssignments from "./en/admin/assignments.json";
import enAdminSettings from "./en/admin/settings.json";
import enAdminBunny from "./en/admin/bunny.json";
import enAdminSupport from "./en/admin/support.json";
import enAdminProfile from "./en/admin/profile.json";
import enAdminHeader from "./en/admin/header.json";
import enAdminPages from "./en/admin/pages.json";
import enAdminResourceUsage from "./en/admin/resourceUsage.json";
import enAdminVideoStudioPromo from "./en/admin/videoStudioPromo.json";
import enAdminOnboarding from "./en/admin/onboarding.json";

import ukAdminSidebar from "./uk/admin/sidebar.json";
import ukAdminDashboard from "./uk/admin/dashboard.json";
import ukAdminCourses from "./uk/admin/courses.json";
import ukAdminModules from "./uk/admin/modules.json";
import ukAdminLessons from "./uk/admin/lessons.json";
import ukAdminStudents from "./uk/admin/students.json";
import ukAdminPayments from "./uk/admin/payments.json";
import ukAdminProducts from "./uk/admin/products.json";
import ukAdminAssignments from "./uk/admin/assignments.json";
import ukAdminSettings from "./uk/admin/settings.json";
import ukAdminBunny from "./uk/admin/bunny.json";
import ukAdminSupport from "./uk/admin/support.json";
import ukAdminProfile from "./uk/admin/profile.json";
import ukAdminHeader from "./uk/admin/header.json";
import ukAdminPages from "./uk/admin/pages.json";
import ukAdminResourceUsage from "./uk/admin/resourceUsage.json";
import ukAdminVideoStudioPromo from "./uk/admin/videoStudioPromo.json";
import ukAdminOnboarding from "./uk/admin/onboarding.json";

import plAdminSidebar from "./pl/admin/sidebar.json";
import plAdminDashboard from "./pl/admin/dashboard.json";
import plAdminCourses from "./pl/admin/courses.json";
import plAdminModules from "./pl/admin/modules.json";
import plAdminLessons from "./pl/admin/lessons.json";
import plAdminStudents from "./pl/admin/students.json";
import plAdminPayments from "./pl/admin/payments.json";
import plAdminProducts from "./pl/admin/products.json";
import plAdminAssignments from "./pl/admin/assignments.json";
import plAdminSettings from "./pl/admin/settings.json";
import plAdminBunny from "./pl/admin/bunny.json";
import plAdminSupport from "./pl/admin/support.json";
import plAdminProfile from "./pl/admin/profile.json";
import plAdminHeader from "./pl/admin/header.json";
import plAdminPages from "./pl/admin/pages.json";
import plAdminResourceUsage from "./pl/admin/resourceUsage.json";
import plAdminVideoStudioPromo from "./pl/admin/videoStudioPromo.json";
import plAdminOnboarding from "./pl/admin/onboarding.json";

import ruAdminSidebar from "./ru/admin/sidebar.json";
import ruAdminDashboard from "./ru/admin/dashboard.json";
import ruAdminCourses from "./ru/admin/courses.json";
import ruAdminModules from "./ru/admin/modules.json";
import ruAdminLessons from "./ru/admin/lessons.json";
import ruAdminStudents from "./ru/admin/students.json";
import ruAdminPayments from "./ru/admin/payments.json";
import ruAdminProducts from "./ru/admin/products.json";
import ruAdminAssignments from "./ru/admin/assignments.json";
import ruAdminSettings from "./ru/admin/settings.json";
import ruAdminBunny from "./ru/admin/bunny.json";
import ruAdminSupport from "./ru/admin/support.json";
import ruAdminProfile from "./ru/admin/profile.json";
import ruAdminHeader from "./ru/admin/header.json";
import ruAdminPages from "./ru/admin/pages.json";
import ruAdminResourceUsage from "./ru/admin/resourceUsage.json";
import ruAdminVideoStudioPromo from "./ru/admin/videoStudioPromo.json";
import ruAdminOnboarding from "./ru/admin/onboarding.json";

import enStudentCabinet from "./en/student/cabinet.json";
import enStudentLesson from "./en/student/lesson.json";
import enStudentModules from "./en/student/modules.json";
import enStudentMessages from "./en/student/messages.json";
import enStudentProgress from "./en/student/progress.json";
import enStudentBilling from "./en/student/billing.json";
import enStudentProducts from "./en/student/products.json";

import ukStudentCabinet from "./uk/student/cabinet.json";
import ukStudentLesson from "./uk/student/lesson.json";
import ukStudentModules from "./uk/student/modules.json";
import ukStudentMessages from "./uk/student/messages.json";
import ukStudentProgress from "./uk/student/progress.json";
import ukStudentBilling from "./uk/student/billing.json";
import ukStudentProducts from "./uk/student/products.json";

import plStudentCabinet from "./pl/student/cabinet.json";
import plStudentLesson from "./pl/student/lesson.json";
import plStudentModules from "./pl/student/modules.json";
import plStudentMessages from "./pl/student/messages.json";
import plStudentProgress from "./pl/student/progress.json";
import plStudentBilling from "./pl/student/billing.json";
import plStudentProducts from "./pl/student/products.json";

import ruStudentCabinet from "./ru/student/cabinet.json";
import ruStudentLesson from "./ru/student/lesson.json";
import ruStudentModules from "./ru/student/modules.json";
import ruStudentMessages from "./ru/student/messages.json";
import ruStudentProgress from "./ru/student/progress.json";
import ruStudentBilling from "./ru/student/billing.json";
import ruStudentProducts from "./ru/student/products.json";

import enVideoStudioCommon from "./en/videoStudio/common.json";
import enVideoStudioEntry from "./en/videoStudio/entry.json";
import enVideoStudioWorkspace from "./en/videoStudio/workspace.json";
import enVideoStudioSubtitles from "./en/videoStudio/subtitles.json";
import enVideoStudioTimeline from "./en/videoStudio/timeline.json";
import enVideoStudioQuestions from "./en/videoStudio/questions.json";
import enVideoStudioChapters from "./en/videoStudio/chapters.json";
import enVideoStudioFiles from "./en/videoStudio/files.json";
import enVideoStudioSettings from "./en/videoStudio/settings.json";
import enVideoStudioAiGenerate from "./en/videoStudio/aiGenerate.json";
import enVideoStudioAiMaterials from "./en/videoStudio/aiMaterials.json";
import enVideoStudioImages from "./en/videoStudio/images.json";

import ukVideoStudioCommon from "./uk/videoStudio/common.json";
import ukVideoStudioEntry from "./uk/videoStudio/entry.json";
import ukVideoStudioWorkspace from "./uk/videoStudio/workspace.json";
import ukVideoStudioSubtitles from "./uk/videoStudio/subtitles.json";
import ukVideoStudioTimeline from "./uk/videoStudio/timeline.json";
import ukVideoStudioQuestions from "./uk/videoStudio/questions.json";
import ukVideoStudioChapters from "./uk/videoStudio/chapters.json";
import ukVideoStudioFiles from "./uk/videoStudio/files.json";
import ukVideoStudioSettings from "./uk/videoStudio/settings.json";
import ukVideoStudioAiGenerate from "./uk/videoStudio/aiGenerate.json";
import ukVideoStudioAiMaterials from "./uk/videoStudio/aiMaterials.json";
import ukVideoStudioImages from "./uk/videoStudio/images.json";

import plVideoStudioCommon from "./pl/videoStudio/common.json";
import plVideoStudioEntry from "./pl/videoStudio/entry.json";
import plVideoStudioWorkspace from "./pl/videoStudio/workspace.json";
import plVideoStudioSubtitles from "./pl/videoStudio/subtitles.json";
import plVideoStudioTimeline from "./pl/videoStudio/timeline.json";
import plVideoStudioQuestions from "./pl/videoStudio/questions.json";
import plVideoStudioChapters from "./pl/videoStudio/chapters.json";
import plVideoStudioFiles from "./pl/videoStudio/files.json";
import plVideoStudioSettings from "./pl/videoStudio/settings.json";
import plVideoStudioAiGenerate from "./pl/videoStudio/aiGenerate.json";
import plVideoStudioAiMaterials from "./pl/videoStudio/aiMaterials.json";
import plVideoStudioImages from "./pl/videoStudio/images.json";

import ruVideoStudioCommon from "./ru/videoStudio/common.json";
import ruVideoStudioEntry from "./ru/videoStudio/entry.json";
import ruVideoStudioWorkspace from "./ru/videoStudio/workspace.json";
import ruVideoStudioSubtitles from "./ru/videoStudio/subtitles.json";
import ruVideoStudioTimeline from "./ru/videoStudio/timeline.json";
import ruVideoStudioQuestions from "./ru/videoStudio/questions.json";
import ruVideoStudioChapters from "./ru/videoStudio/chapters.json";
import ruVideoStudioFiles from "./ru/videoStudio/files.json";
import ruVideoStudioSettings from "./ru/videoStudio/settings.json";
import ruVideoStudioAiGenerate from "./ru/videoStudio/aiGenerate.json";
import ruVideoStudioAiMaterials from "./ru/videoStudio/aiMaterials.json";
import ruVideoStudioImages from "./ru/videoStudio/images.json";

import enLandingBuilderCommon from "./en/landingBuilder/common.json";
import enLandingBuilderTopbar from "./en/landingBuilder/topbar.json";
import enLandingBuilderInspector from "./en/landingBuilder/inspector.json";
import enLandingBuilderTemplates from "./en/landingBuilder/templates.json";
import enLandingBuilderThemes from "./en/landingBuilder/themes.json";
import enLandingBuilderCourseSales from "./en/landingBuilder/courseSales.json";

import ukLandingBuilderCommon from "./uk/landingBuilder/common.json";
import ukLandingBuilderTopbar from "./uk/landingBuilder/topbar.json";
import ukLandingBuilderInspector from "./uk/landingBuilder/inspector.json";
import ukLandingBuilderTemplates from "./uk/landingBuilder/templates.json";
import ukLandingBuilderThemes from "./uk/landingBuilder/themes.json";
import ukLandingBuilderCourseSales from "./uk/landingBuilder/courseSales.json";

import plLandingBuilderCommon from "./pl/landingBuilder/common.json";
import plLandingBuilderTopbar from "./pl/landingBuilder/topbar.json";
import plLandingBuilderInspector from "./pl/landingBuilder/inspector.json";
import plLandingBuilderTemplates from "./pl/landingBuilder/templates.json";
import plLandingBuilderThemes from "./pl/landingBuilder/themes.json";
import plLandingBuilderCourseSales from "./pl/landingBuilder/courseSales.json";

import ruLandingBuilderCommon from "./ru/landingBuilder/common.json";
import ruLandingBuilderTopbar from "./ru/landingBuilder/topbar.json";
import ruLandingBuilderInspector from "./ru/landingBuilder/inspector.json";
import ruLandingBuilderTemplates from "./ru/landingBuilder/templates.json";
import ruLandingBuilderThemes from "./ru/landingBuilder/themes.json";
import ruLandingBuilderCourseSales from "./ru/landingBuilder/courseSales.json";

import enCertificateStudioCommon from "./en/certificateStudio/common.json";
import ukCertificateStudioCommon from "./uk/certificateStudio/common.json";
import plCertificateStudioCommon from "./pl/certificateStudio/common.json";
import ruCertificateStudioCommon from "./ru/certificateStudio/common.json";



export const SUPPORTED_LANGUAGES = ["en", "uk", "pl", "ru"];
export const FALLBACK_LANGUAGE = "en";
export const LANGUAGE_MODE_STORAGE_KEY = "lang_mode";
export const LANGUAGE_STORAGE_KEY = "lang";
export const LANGUAGE_MODE_AUTO = "auto";
export const LANGUAGE_MODE_MANUAL = "manual";

function getCookie(name) {
  if (typeof document === "undefined") return null;

  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

export function normalizeLanguage(value) {
  const normalized = String(value || "").split("-")[0].toLowerCase();
  return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : "";
}

function getStoredLanguage() {
  if (typeof window === "undefined") return "";

  const mode = getStoredLanguageMode();

  if (mode === LANGUAGE_MODE_AUTO) {
    return "";
  }

  try {
    const localStorageLanguage = normalizeLanguage(
        window.localStorage.getItem(LANGUAGE_STORAGE_KEY),
    );

    if (localStorageLanguage) return localStorageLanguage;
  } catch {}

  return normalizeLanguage(getCookie(LANGUAGE_STORAGE_KEY));
}

export function getBrowserLanguage() {
  if (typeof navigator === "undefined") return "";

  const languages = Array.isArray(navigator.languages)
      ? navigator.languages
      : [navigator.language];

  for (const language of languages) {
    const normalized = normalizeLanguage(language);
    if (normalized) return normalized;
  }

  return "";
}
export function clearStoredLanguagePreference() {
  return setAutoLanguagePreference();
}

export function resolveBrowserLanguage() {
  return getBrowserLanguage() || FALLBACK_LANGUAGE;
}

function resolveInitialLanguage() {
  return getStoredLanguage() || getBrowserLanguage() || FALLBACK_LANGUAGE;
}

function buildTranslation({
                            legacy,
                            common,
                            notifications,
                            voice,
                            admin,
                            student,
                            videoStudio,
                            landingBuilder,
                            certificateStudio,
                            community,
                            pricing,
                          }) {
  return {
    ...legacy,
    common,
    notifications,
    voice,
    admin,
    student,
    videoStudio,
    landingBuilder,
    certificateStudio,
    community,
    pricing,
  };
}

const resources = {
  en: {
    translation: buildTranslation({
      legacy: legacyEn,
      common: enCommon,
      notifications: enNotifications,
      voice: enVoice,
      admin: {
        sidebar: enAdminSidebar,
        dashboard: enAdminDashboard,
        courses: enAdminCourses,
        modules: enAdminModules,
        lessons: enAdminLessons,
        students: enAdminStudents,
        payments: enAdminPayments,
        products: enAdminProducts,
        assignments: enAdminAssignments,
        settings: enAdminSettings,
        bunny: enAdminBunny,
        support: enAdminSupport,
        profile: enAdminProfile,
        header: enAdminHeader,
        pages: enAdminPages,
        resourceUsage: enAdminResourceUsage,
        videoStudioPromo: enAdminVideoStudioPromo,
        onboarding: enAdminOnboarding,
      },
      student: {
        cabinet: enStudentCabinet,
        lesson: enStudentLesson,
        modules: enStudentModules,
        messages: enStudentMessages,
        progress: enStudentProgress,
        billing: enStudentBilling,
        products: enStudentProducts,
      },
      videoStudio: {
        common: enVideoStudioCommon,
        entry: enVideoStudioEntry,
        workspace: enVideoStudioWorkspace,
        subtitles: enVideoStudioSubtitles,
        timeline: enVideoStudioTimeline,
        questions: enVideoStudioQuestions,
        chapters: enVideoStudioChapters,
        files: enVideoStudioFiles,
        images: enVideoStudioImages,
        settings: enVideoStudioSettings,
        aiGenerate: enVideoStudioAiGenerate,
        aiMaterials: enVideoStudioAiMaterials,
      },
      landingBuilder: {
        common: enLandingBuilderCommon,
        topbar: enLandingBuilderTopbar,
        inspector: enLandingBuilderInspector,
        templates: enLandingBuilderTemplates,
        themes: enLandingBuilderThemes,
        courseSales: enLandingBuilderCourseSales,
      },
      certificateStudio: enCertificateStudioCommon,
      community: {
        common: enCommunityCommon,
      },
      pricing: {
        common: enPricingCommon,
      },
    }),
  },

  uk: {
    translation: buildTranslation({
      legacy: legacyUk,
      common: ukCommon,
      notifications: ukNotifications,
      voice: ukVoice,
      admin: {
        sidebar: ukAdminSidebar,
        dashboard: ukAdminDashboard,
        courses: ukAdminCourses,
        modules: ukAdminModules,
        lessons: ukAdminLessons,
        students: ukAdminStudents,
        payments: ukAdminPayments,
        products: ukAdminProducts,
        assignments: ukAdminAssignments,
        settings: ukAdminSettings,
        bunny: ukAdminBunny,
        support: ukAdminSupport,
        profile: ukAdminProfile,
        header: ukAdminHeader,
        pages: ukAdminPages,
        resourceUsage: ukAdminResourceUsage,
        videoStudioPromo: ukAdminVideoStudioPromo,
        onboarding: ukAdminOnboarding,
      },
      student: {
        cabinet: ukStudentCabinet,
        lesson: ukStudentLesson,
        modules: ukStudentModules,
        messages: ukStudentMessages,
        progress: ukStudentProgress,
        billing: ukStudentBilling,
        products: ukStudentProducts,
      },
      videoStudio: {
        common: ukVideoStudioCommon,
        entry: ukVideoStudioEntry,
        workspace: ukVideoStudioWorkspace,
        subtitles: ukVideoStudioSubtitles,
        timeline: ukVideoStudioTimeline,
        questions: ukVideoStudioQuestions,
        chapters: ukVideoStudioChapters,
        files: ukVideoStudioFiles,
        images: ukVideoStudioImages,
        settings: ukVideoStudioSettings,
        aiGenerate: ukVideoStudioAiGenerate,
        aiMaterials: ukVideoStudioAiMaterials,
      },
      landingBuilder: {
        common: ukLandingBuilderCommon,
        topbar: ukLandingBuilderTopbar,
        inspector: ukLandingBuilderInspector,
        templates: ukLandingBuilderTemplates,
        themes: ukLandingBuilderThemes,
        courseSales: ukLandingBuilderCourseSales,
      },
      certificateStudio: ukCertificateStudioCommon,
      community: {
        common: ukCommunityCommon,
      },
      pricing: {
        common: ukPricingCommon,
      },
    }),
  },

  pl: {
    translation: buildTranslation({
      legacy: legacyPl,
      common: plCommon,
      notifications: plNotifications,
      voice: plVoice,
      admin: {
        sidebar: plAdminSidebar,
        dashboard: plAdminDashboard,
        courses: plAdminCourses,
        modules: plAdminModules,
        lessons: plAdminLessons,
        students: plAdminStudents,
        payments: plAdminPayments,
        products: plAdminProducts,
        assignments: plAdminAssignments,
        settings: plAdminSettings,
        bunny: plAdminBunny,
        support: plAdminSupport,
        profile: plAdminProfile,
        header: plAdminHeader,
        pages: plAdminPages,
        resourceUsage: plAdminResourceUsage,
        videoStudioPromo: plAdminVideoStudioPromo,
        onboarding: plAdminOnboarding,
      },
      student: {
        cabinet: plStudentCabinet,
        lesson: plStudentLesson,
        modules: plStudentModules,
        messages: plStudentMessages,
        progress: plStudentProgress,
        billing: plStudentBilling,
        products: plStudentProducts,
      },
      videoStudio: {
        common: plVideoStudioCommon,
        entry: plVideoStudioEntry,
        workspace: plVideoStudioWorkspace,
        subtitles: plVideoStudioSubtitles,
        timeline: plVideoStudioTimeline,
        questions: plVideoStudioQuestions,
        chapters: plVideoStudioChapters,
        files: plVideoStudioFiles,
        images: plVideoStudioImages,
        settings: plVideoStudioSettings,
        aiGenerate: plVideoStudioAiGenerate,
        aiMaterials: plVideoStudioAiMaterials,
      },
      landingBuilder: {
        common: plLandingBuilderCommon,
        topbar: plLandingBuilderTopbar,
        inspector: plLandingBuilderInspector,
        templates: plLandingBuilderTemplates,
        themes: plLandingBuilderThemes,
        courseSales: plLandingBuilderCourseSales,
      },
      certificateStudio: plCertificateStudioCommon,
      community: {
        common: plCommunityCommon,
      },
      pricing: {
        common: plPricingCommon,
      },
    }),
  },

  ru: {
    translation: buildTranslation({
      legacy: legacyRu,
      common: ruCommon,
      notifications: ruNotifications,
      voice: ruVoice,
      admin: {
        sidebar: ruAdminSidebar,
        dashboard: ruAdminDashboard,
        courses: ruAdminCourses,
        modules: ruAdminModules,
        lessons: ruAdminLessons,
        students: ruAdminStudents,
        payments: ruAdminPayments,
        products: ruAdminProducts,
        assignments: ruAdminAssignments,
        settings: ruAdminSettings,
        bunny: ruAdminBunny,
        support: ruAdminSupport,
        profile: ruAdminProfile,
        header: ruAdminHeader,
        pages: ruAdminPages,
        resourceUsage: ruAdminResourceUsage,
        videoStudioPromo: ruAdminVideoStudioPromo,
        onboarding: ruAdminOnboarding,
      },
      student: {
        cabinet: ruStudentCabinet,
        lesson: ruStudentLesson,
        modules: ruStudentModules,
        messages: ruStudentMessages,
        progress: ruStudentProgress,
        billing: ruStudentBilling,
        products: ruStudentProducts,
      },
      videoStudio: {
        common: ruVideoStudioCommon,
        entry: ruVideoStudioEntry,
        workspace: ruVideoStudioWorkspace,
        subtitles: ruVideoStudioSubtitles,
        timeline: ruVideoStudioTimeline,
        questions: ruVideoStudioQuestions,
        chapters: ruVideoStudioChapters,
        files: ruVideoStudioFiles,
        images: ruVideoStudioImages,
        settings: ruVideoStudioSettings,
        aiGenerate: ruVideoStudioAiGenerate,
        aiMaterials: ruVideoStudioAiMaterials,
      },
      landingBuilder: {
        common: ruLandingBuilderCommon,
        topbar: ruLandingBuilderTopbar,
        inspector: ruLandingBuilderInspector,
        templates: ruLandingBuilderTemplates,
        themes: ruLandingBuilderThemes,
        courseSales: ruLandingBuilderCourseSales,
      },
      certificateStudio: ruCertificateStudioCommon,
      community: {
        common: ruCommunityCommon,
      },
      pricing: {
        common: ruPricingCommon,
      },
    }),
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLanguage(),
  fallbackLng: FALLBACK_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  const normalized = normalizeLanguage(lng) || FALLBACK_LANGUAGE;
  const mode = getStoredLanguageMode();

  if (mode === LANGUAGE_MODE_AUTO) {
    return;
  }

  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
    window.localStorage.setItem(LANGUAGE_MODE_STORAGE_KEY, LANGUAGE_MODE_MANUAL);
  } catch {}

  if (typeof document !== "undefined") {
    document.cookie = `${LANGUAGE_STORAGE_KEY}=${normalized}; path=/; max-age=31536000; SameSite=Lax`;
  }
});
function getStoredLanguageMode() {
  if (typeof window === "undefined") return LANGUAGE_MODE_AUTO;

  try {
    const value = String(
        window.localStorage.getItem(LANGUAGE_MODE_STORAGE_KEY) || "",
    )
        .trim()
        .toLowerCase();

    if (value === LANGUAGE_MODE_MANUAL) return LANGUAGE_MODE_MANUAL;
    if (value === LANGUAGE_MODE_AUTO) return LANGUAGE_MODE_AUTO;
  } catch {}

  return LANGUAGE_MODE_AUTO;
}

export function setManualLanguagePreference(language) {
  const normalized = normalizeLanguage(language) || FALLBACK_LANGUAGE;

  try {
    window.localStorage.setItem(LANGUAGE_MODE_STORAGE_KEY, LANGUAGE_MODE_MANUAL);
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  } catch {}

  if (typeof document !== "undefined") {
    document.cookie = `${LANGUAGE_STORAGE_KEY}=${normalized}; path=/; max-age=31536000; SameSite=Lax`;
  }

  return normalized;
}

export function setAutoLanguagePreference() {
  try {
    window.localStorage.setItem(LANGUAGE_MODE_STORAGE_KEY, LANGUAGE_MODE_AUTO);
    window.localStorage.removeItem(LANGUAGE_STORAGE_KEY);
  } catch {}

  if (typeof document !== "undefined") {
    document.cookie = `${LANGUAGE_STORAGE_KEY}=; path=/; max-age=0; SameSite=Lax`;
  }

  return resolveBrowserLanguage();
}

export default i18n;
